
let baseURL = '';
let ppsUrl = '';
if(process.env.NODE_ENV == 'development'){
    baseURL = 'http://lloa.c.qiema.cc/admin/v1';
    ppsUrl = 'http://lloa.c.qiema.cc/admin/v1';
}else if(process.env.NODE_ENV == 'production'){
    baseURL = 'https://lloa.api.qiema.cn/admin/v1';
    ppsUrl = 'https://lloa.c.qiema.cc/admin/v1';
}else{
    baseURL = 'http://lloa.c.qiema.cc/admin/v1';
    ppsUrl = 'http://lloa.c.qiema.cc/admin/v1';
}
export default {
    baseURL,
    ppsUrl
}